module.exports = __webpack_public_path__ + "static/img/cs1.a2e4277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cs1.png
// module id = IJQZ
// module chunks = 0